import React, {useLayoutEffect, useRef} from 'react';
import {toggleClassForNode} from "../../../../../gd/utils/dom-and-react/react-utils";
import MoreOptions from "./more-options";
import FieldReaction from "../../reaction";
import Reactions from "../../../../../model2/reaction/reactions";
import {Group} from "../../../../../data-structures/group";
import ReactionView from "../../../../../gd-components/reactions/reactions-list/reaction-view";
import Reaction from "../../../../../model2/reaction/reaction";

type Props = {
    field           : FieldReaction
    model           : any,
    columnWidth?    : number,
    isHovered?      : boolean

    onValueChange?  : callback
    // onChange?       : onChangeCallback
};

const BUTTONS_WIDTH = 74 // buttons that are shown on hover have width 48px + 10px margin + 16px padding

// const debug = "FieldMultiselect_TableView"
const debug = false

export default function FieldReaction_TableCellValue(props:Props) {

    const selfRef           : any = useRef()
    const moreOptionsRef    : any = useRef()

    debug && console.log(debug, 'render', props)

    const field         = props.field as unknown as FieldReaction
    const value         = _.get(props.model, props.field.fieldId, null)
    const reactions : Reactions = Reactions.initFromJson(value)


    const onToggle = (reaction:any) => {
        debug && console.log(debug, "onToggle reaction=", reaction, "onValueChange", props.onValueChange)
        const newValue : any = field.toggleValue(props.model, reaction)

        props.onValueChange && props.onValueChange(newValue)
    }

    useLayoutEffect(() => {
        if (selfRef.current) {
            // reserve space for buttons while not hovered
            // when is hovered width is already reduced by buttons width
            const hoverButtonsWidth = /*props.isHovered? 0 :*/ BUTTONS_WIDTH

            let moreOptions = 0
            const selfRect = selfRef.current.getBoundingClientRect()
            let rightBorder = selfRect.left + props.columnWidth - hoverButtonsWidth

            debug && console.log(debug, 'useLayoutEffect', rightBorder, selfRect, selfRef.current)

            // check child nodes in reverse order (from last to first)
            const nodes = _.reverse([...selfRef.current.childNodes])
            _.map(nodes, node=>{
                toggleClassForNode(node, 'display-none', false) // make node visible in order to have actual component rect
            })

            _.map(nodes, node=>{
                if (node.classList.contains('more-options')) return // skip more-options component

                const nodeRect = node.getBoundingClientRect()
                // if node's right border is more than container border then it is beyond available borders
                const isFit = rightBorder > nodeRect.right

                debug && console.log(debug, 'useLayoutEffect node', isFit, nodeRect, node)

                toggleClassForNode(node, 'display-none', !isFit) // hide nodes that do not fit available width

                // increase moreOptions
                if (!isFit) {
                    moreOptions++
                }

                // if any more options then available width is reduced
                // move threshold border to the left by the more options component width (~20px)
                if (moreOptions === 1) {
                    rightBorder -= 20
                }
            })

            // set more options counter
            moreOptionsRef.current.setMoreOptions(moreOptions)
        }
    }, [props.columnWidth])




    if (reactions.isEmpty) return null

    return (
        <div className="ui5-reactions flex-no-wrap w-100-percent" ref={selfRef}>

            {_.map(reactions.groupedByType, (reactionsGroup: Group, key:string) =>
                <ReactionView key           = {key}
                              reactionType  = {reactionsGroup.value}
                              reactions     = {reactionsGroup.items as Reaction[]}
                              onClick       = {onToggle}/>
            )}

            <MoreOptions ref={moreOptionsRef}/>
        </div>
    )
}